var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { ref } from "vue";
import { core } from "./core.js";
class TranslationProvider {
  constructor(config) {
    __publicField(this, "config");
    __publicField(this, "_currentLanguage", ref(""));
    __publicField(this, "_initialized", false);
    this.config = config;
  }
  get currentLanguage() {
    return this._currentLanguage.value;
  }
  /**
    Initialises the provider with default language
    Will try to parse browser language or fallback to provided default language
   */
  async initialize() {
    this._initialized = true;
    await this.set(core.getDefaultLanguage(this.config));
  }
  /**
   * Set a new language
   * Order of loading translations; cloud service then local storage
   * @param language - The language to set
   * @param hooks - Optional hooks
   * @param hooks.updated - Callback when language is updated
   * @param hooks.unsupported - Callback when language is not supported
   */
  async set(language, hooks) {
    var _a, _b;
    if (!this._initialized) {
      throw new Error("TranslationProvider not initialized");
    }
    const { supported, logger, loadLocalTranslation } = this.config;
    if (language === this.currentLanguage) {
      return;
    }
    if (!supported.includes(language)) {
      logger.warn("Language not supported", { language });
      (_a = hooks == null ? void 0 : hooks.unsupported) == null ? void 0 : _a.call(hooks);
      return;
    }
    let translations;
    try {
      translations = await core.loadCloudTranslation(language, this.config);
    } catch (cloudError) {
      logger.error(
        "Translations failed to load via Translations Cloud Service",
        { error: cloudError }
      );
      try {
        translations = await loadLocalTranslation(language);
      } catch (e) {
        logger.error("Translations failed to load locally", { error: e });
      }
    }
    if (translations) {
      this._currentLanguage.value = language;
      await Promise.all([
        this.config.afterTranslationChanged(language, translations),
        (_b = hooks == null ? void 0 : hooks.updated) == null ? void 0 : _b.call(hooks, language)
      ]);
    }
  }
}
export {
  TranslationProvider
};
